import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Admin from "./routes/Admin";
import Public from "./routes/Public";
import NotFound from "./pages/NotFound/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {Public()}
        {Admin()}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
